import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import moment from 'moment';
import { notification } from 'antd';

export default class StatsStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    date: moment().format('YYYY-MM'),
    date2: moment().subtract(1, 'month').format('YYYY-MM'),

    strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),

    strDate2: moment().subtract(1, 'year').subtract(1, 'month').format('YYYY-MM-DD'),
    endDate2: moment().subtract(1, 'year').format('YYYY-MM-DD'),

    statsType: 'month',
    gdCd: '',
    jobCd: '',
    orBranchCd: '',
    orBranchNm: '전체'
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  @observable
  _statsGoods = [];

  @computed
  get statsGoods() {
    return this._statsGoods;
  }

  @observable
  _statsJob = [];

  @computed
  get statsJob() {
    return this._statsJob;
  }

  @action
  onClear = () => {
    this._statsGoods = [];
    this._statsJob = [];

    this._goodsList = [];
    this._jobList = [];

    this._valCondition = {
      date: moment().format('YYYY-MM'),
      date2: moment().subtract(1, 'month').format('YYYY-MM'),

      strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),

      strDate2: moment().subtract(1, 'year').subtract(1, 'month').format('YYYY-MM-DD'),
      endDate2: moment().subtract(1, 'year').format('YYYY-MM-DD'),

      statsType: 'month',
      gdCd: '',
      jobCd: '',
      orBranchCd: '',
      orBranchNm: '전체'
    };
  };

  //----------------------------------
  // 상품+사이즈 통계
  @action
  disStatsGoods = async (gdCd, orBranchCd) => {
    if (gdCd !== undefined && gdCd !== null && this._valCondition.gdCd !== gdCd) {
      this._valCondition.gdCd = gdCd;
    }

    if (orBranchCd !== undefined && orBranchCd !== null && this._valCondition.orBranchCd !== orBranchCd) {
      this._valCondition.orBranchCd = orBranchCd;
    }
    
    let addition = new Addition();
    addition.setCmdName('DIS-STATS-GOODS');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'statsType', paraValue: this._valCondition.statsType});
    reqInputMsg.addParam({paraName: 'gdCd', paraValue: this._valCondition.gdCd});
    reqInputMsg.addParam({paraName: 'orBranchCd', paraValue: this._valCondition.orBranchCd});

    reqInputMsg.addParam({paraName: 'date', paraValue: this._valCondition.date });
    reqInputMsg.addParam({paraName: 'date2', paraValue: this._valCondition.date2 });

    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate });
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate });
    reqInputMsg.addParam({paraName: 'strDate2', paraValue: this._valCondition.strDate2 });
    reqInputMsg.addParam({paraName: 'endDate2', paraValue: this._valCondition.endDate2 });

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._statsGoods = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`데이터를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._statsGoods = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._statsGoods = [];
        console.log('error', error);
      });
  };

  // 직무+상품+사이즈 통계
  @action
  disStatsJob = async (jobCd) => {
    if (jobCd !== undefined && jobCd !== null && this._valCondition.jobCd !== jobCd) {
      this._valCondition.jobCd = jobCd;
    }

    let addition = new Addition();
    addition.setCmdName('DIS-STATS-JOB');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'statsType', paraValue: this._valCondition.statsType});
    reqInputMsg.addParam({paraName: 'jobCd', paraValue: this._valCondition.jobCd});

    reqInputMsg.addParam({paraName: 'date', paraValue: this._valCondition.date });
    reqInputMsg.addParam({paraName: 'date2', paraValue: this._valCondition.date2 });

    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate });
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate });
    reqInputMsg.addParam({paraName: 'strDate2', paraValue: this._valCondition.strDate2 });
    reqInputMsg.addParam({paraName: 'endDate2', paraValue: this._valCondition.endDate2 });

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._statsJob = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`데이터를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._statsJob = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._statsJob = [];
        console.log('error', error);
      });
  };

  // 상품 리스트
  @observable
  _goodsList = [];

  @computed
  get goodsList() {
    return this._goodsList;
  }

  @action
  disGoodsList = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-GOODS-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    
    return await callCmd(reqInputMsg, 'goodsInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._goodsList = res.result;
          if (this._goodsList.length > 0) {
            this.disStatsGoods();
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`상품 리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._goodsList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._goodsList = [];
        console.log('error', error);
      });
  };
}
  
